import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import VueFeather from 'vue-feather';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import '@/assets/scss/main.scss';

const app = createApp(App);
app.use(router);
app.component(VueFeather.name, VueFeather);
app.use(Toast);
app.mount('#app');
